<template>
    <div id="mobile-details-advantages">
        <template v-if="isAuthenticated">
            <h2 class="no-signature lead font-weight-bold mb-0" v-html="labels.loggedLabels.title" />
            <p class="mb-0" v-html="labels.loggedLabels.text" />
            <ob1-liens
                :with-arrow="true"
                :text="labels.loggedLabels.linkLabel"
                :data-oevent-category="labels.loggedTmsDTO.tagZone"
                :data-oevent-action="labels.loggedTmsDTO.tagName"
                :data-oevent-label="labels.loggedTmsDTO.tagTarget"
                :href="labels.href"
            />
        </template>
    </div>
</template>
<script>
export default {
    name: "MobileDetailsAdvantages",
    props: {
        isAuthenticated: {
            type: Boolean,
            default: false
        },
        labels: {
            type: Object,
            required: true
        }
    }
}
</script>
